// extracted by mini-css-extract-plugin
export default {"rangeTicks":"RangeTicks-module__rangeTicks___gh10n","tick":"RangeTicks-module__tick___RPg9R","label":"RangeTicks-module__label___iJkrM"};